<template>
  <d-list-group flush>
    <d-list-group-item class="p-0">
      <d-row>
        <d-col md="12" class="form-group">
          <d-form>
            <d-card class="card-small">
              <!-- Card Header -->
              <d-card-header class="border-bottom">
                <h6 class="m-0">Lista de Itens Inclusos</h6>
              </d-card-header>

              <d-card-body class="p-0 pb-1">
                <item-form-row
                  :list="itemsIncluded"
                  type="itemsIncluded"
                  @saveItem="saveItemsIncluded"
                  @editItem="editItemsIncluded"
                  placeholder="Adicione um Item Incluso"
                />
              </d-card-body>
            </d-card>
          </d-form>
        </d-col>
      </d-row>
    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import SettingsService from '_services/rest/modules/settings';
import ContractualItems from '_common/mixins/ContractualItems';
import ItemFormRow from './ItemFormRow.vue';
import { OPTION } from './SettingsModel';
import { _OPEN_EDITOR_TEXT_MODAL_ } from '../../quotation/components/QuotationModel';

export default {
  name: 'items-included-form',
  mixins: [ContractualItems],
  components: {
    ItemFormRow,
  },
  data() {
    return {};
  },
  computed: {
    itemsIncluded() {
      const { itemsIncluded } = this.$store.state.settings;
      if (itemsIncluded && itemsIncluded.length > 0) {
        return itemsIncluded;
      }
      return [{ ...OPTION }];
    },
  },
  methods: {
    ...mapActions(['getItemsIncluded', 'setToggle', 'activeAlert']),
    getOptions() {
      this.getItemsIncluded();
    },
    editItemsIncluded({ item, type, index }) {
      this.setToggle({ type: 'edit_editor_text_modal', bool: true });
      Events.$emit(_OPEN_EDITOR_TEXT_MODAL_, { item, type, index });
    },
    saveItemsIncluded({ index, type = 'itemsIncluded' }) {
      this.formatSlug(this[type][index]);
      SettingsService.saveQuotationContractualItems(this[type][index], 'items_included')
        .then(response => {
          this.updateItem(index, type, response);
          this.activeAlert({
            message: 'Item incluso salvo com sucesso',
            theme: 'success',
          });
          if (this.itemsIncluded.length === 1) this.getOptions();
        })
        .catch(error => {
          this.activeAlert({
            message: `${error.message} <br/> ${error.data}`,
            theme: 'danger',
          });
        });
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>
